const useStyles = (theme) => ({
  pageBox: {
    paddingInline: 1,
    paddingTop: 1,
    paddingBottom: 1,
    display: "flex",
    flexDirection: "column",
    height: "calc(100vh - 65px)",
  },
  // Paper externo: título + botões + tabela (cor background.paper)
  outerPaper: {
    flexGrow: 1,
    borderRadius: "15px",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
    padding: 4,
    gap: 2,
  },
  headerBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexShrink: 0,
  },
  title: {
    fontWeight: "bold",
    color: theme.palette.text.primary,
  },
  actionsBox: {
    display: "flex",
    gap: 2,
  },
  // Paper interno: só a tabela (cor wallpaper / background.default)
  innerPaper: {
    flexGrow: 1,
    borderRadius: "12px",
    overflow: "hidden",
    // backgroundColor: theme.palette.background.default,
    "& .MuiDataGrid-root": {
      border: "none",
    },
  },
});

export default useStyles;
